<template>
  <div>
    <CrudList
      title="Días disponibles"
      storeName="Available_days"
      :parentStoreName="'Users/'+$route.params.user_id+'/Spots'"
      parentUrlKey="spot_id"
      labelAddNew="Agregar"
      :canAdd="true"
      :canEdit="true"
      :canDelete="true"
      labelBack="Atrás"
    >
      <template v-slot:available_hours="{ item }">
        <p v-for="(available_hour,index) of item.available_hour" :key="index">{{available_hour.hour_from}} - {{available_hour.hour_to}}</p>
      </template>
    </CrudList>
  </div>
</template>

<script>
  import CrudList from "@/components/Crud/CrudList";

  export default {
    components: {CrudList},
    data: () => ({
      offsetTop: 0,
    }),
    methods: {
      onScroll (e) {
        this.offsetTop = e.target.scrollTop
      },

    },
  };
</script>
